import { seasonalDistribution } from 'constants/seasonalDistribution'
import { getCriteriaStatus } from 'utils/speciesCriteriaMet'
import { isGloballySensitiveSpecies, parseSensitiveFlag } from 'utils/sensitiveSpecies'

const getSeasonName = (seasonalDistributionId) => {
  const season = seasonalDistribution.find((item) => item.id === seasonalDistributionId)

  return season?.name || '-'
}

const normalizeTriggerReasonId = (triggerReasonId) => {
  if (triggerReasonId == null) {
    return triggerReasonId
  }

  return Array.isArray(triggerReasonId) ? triggerReasonId : [triggerReasonId]
}

const formatKbaCriteria = (kbaCriterias) => {
  if (!Array.isArray(kbaCriterias) || !kbaCriterias.length) {
    return '-'
  }

  return kbaCriterias.join(', ')
}

const formatIbaCriterias = (ibaCriterias) => {
  if (!Array.isArray(ibaCriterias) || !ibaCriterias.length) {
    return ''
  }

  return ibaCriterias.join(', ')
}

const normalizeKbaCriterias = (kbaCriterias) => {
  if (!Array.isArray(kbaCriterias)) {
    return []
  }

  return kbaCriterias
}

const normalizeAssessmentParameterTypeId = (parameterTypeId) => {
  if (parameterTypeId == null) {
    return null
  }

  return Array.isArray(parameterTypeId) ? parameterTypeId : [parameterTypeId]
}

const buildSpeciesCriteriaStatusMap = (parsed = []) => {
  const speciesMap = new Map()

  parsed.forEach((item) => {
    const key = item.scientificName

    if (!key) {
      return
    }

    if (!speciesMap.has(key)) {
      speciesMap.set(key, {
        triggerReasonId: item.triggerReasonId,
        legacySpecies: item.legacySpecies === true || item.LegacySpecies === true,
        kbaCriterias: new Set()
      })
    }

    const entry = speciesMap.get(key)

    if (item.legacySpecies === true || item.LegacySpecies === true) {
      entry.legacySpecies = true
    }

    if (entry.triggerReasonId == null && item.triggerReasonId != null) {
      entry.triggerReasonId = item.triggerReasonId
    }

    normalizeKbaCriterias(item.kbaCriterias).forEach((criteria) => {
      if (criteria) {
        entry.kbaCriterias.add(criteria)
      }
    })
  })

  const statusMap = new Map()

  speciesMap.forEach((entry, scientificName) => {
    statusMap.set(scientificName, getCriteriaStatus({
      triggerReasonId: entry.triggerReasonId,
      legacySpecies: entry.legacySpecies,
      kbaCriterias: [...entry.kbaCriterias]
    }))
  })

  return statusMap
}

export const mapCalculationDataFromApi = (parsed = []) => {
  if (!Array.isArray(parsed)) {
    return []
  }

  const speciesCriteriaStatusMap = buildSpeciesCriteriaStatusMap(parsed)
  return parsed.map((item) => ({
    taxonGroup: item.taxonomicGroup || item.taxonGroup || '',
    taxonomicGroup: item.taxonomicGroup || item.taxonGroup || '',
    season: { name: getSeasonName(item.SeasonalDistributionId) },
    scientificName: item.scientificName || '',
    commonName: item.specieName || item.mainCommonName || item.commonName || '',
    specieName: item.specieName || item.mainCommonName || item.commonName || '',
    iucnStatus: item.RedListCategoryCode || item.iucnStatus || '',
    siteBest: item.bestSite,
    reproductiveUnits: item.minReproductiveUnits,
    globalPopulation: item.globalPopulation,
    globallySensitive: isGloballySensitiveSpecies(item),
    sensitiveAtSite: parseSensitiveFlag(item.sensitive_at_site),
    kbaCriteria: formatKbaCriteria(item.kbaCriterias),
    ibaCriterias: formatIbaCriterias(item.ibaCriterias),
    siteAssesmentParameterTypeId: normalizeAssessmentParameterTypeId(item.SiteAssesmentParameterTypeId),
    triggerReasonId: normalizeTriggerReasonId(item.triggerReasonId),
    disqualified_iba_trigger: item.disqualified_iba_trigger,
    ibaDisqualified: item.ibaDisqualified,
    legacySpecies: item.legacySpecies === true || item.LegacySpecies === true,
    underAssessment: item.underAssessment === true || item.isReassessed === true,
    criteriaStatus: speciesCriteriaStatusMap.get(item.scientificName) || null
  }))
}
